// import React, { useState } from 'react';
// import './Contact.css'; // Create this CSS file for styling

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     message: ''
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prevState => ({
//       ...prevState,
//       [name]: value
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Add your form submission logic here (e.g., API call)
//     console.log('Form submitted:', formData);
//     alert('Message sent successfully!');
//     setFormData({ name: '', email: '', message: '' });
//   };

//   return (
//     // <div className="contact-container">

//     <div className="contact-container" id="contact">

//       <div className="contact-header">
//         <h1>Contact Me</h1>
//         <p>Please fill out the form below to contact me</p>
//       </div>

//       <form onSubmit={handleSubmit} className="contact-form">
//         <div className="form-group">
//           <label htmlFor="name">Full Name</label>
//           <input
//             type="text"
//             id="name"
//             name="name"
//             placeholder="Enter your FullName"
//             value={formData.name}
//             onChange={handleChange}
//             required
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="email">Email Address</label>
//           <input
//             type="email"
//             id="email"
//             name="email"
//             placeholder="Enter your Email address"
//             value={formData.email}
//             onChange={handleChange}
//             required
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="message">Message</label>
//           <textarea
//             id="message"
//             name="message"
//             placeholder="Enter your Message"
//             rows="5"
//             value={formData.message}
//             onChange={handleChange}
//             required
//           ></textarea>
//         </div>

//         <button type="submit" className="submit-btn">Send</button>
//       </form>

//       <div className="quote-section">
//         <blockquote>
//           "Great development isn't just about building software; it's about solving problems and creating experiences that make a difference."
//         </blockquote>
//       </div>

//       <footer className="contact-footer">
//         <p>© 2025 Viraj Mhatre. All rights reserved.</p>
//       </footer>
//     </div>
//   );
// };

// export default Contact;


import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import './Contact.css';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_4h9hpbe",   // ✅ Your EmailJS service ID
        "template_s4zklso",  // ✅ Your EmailJS template ID
        form.current,
        "Cj7AEV3V1B8nl5L1S"  // ✅ Your EmailJS public key
      )
      .then(
        (result) => {
          alert("✅ Message sent successfully!");
          form.current.reset();
        },
        (error) => {
          alert("❌ Failed to send message. Try again later.");
          console.error(error.text);
        }
      );
  };

  return (
    <div className="contact-container" id="contact">
      <div className="contact-header">
        <h1>Contact Me</h1>
        <p>Please fill out the form below to contact me</p>
      </div>

      <form ref={form} onSubmit={sendEmail} className="contact-form">
        <div className="form-group">
          <label htmlFor="user_name">Full Name</label>
          <input
            type="text"
            id="user_name"
            name="user_name"
            placeholder="Enter your full name"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="user_email">Email Address</label>
          <input
            type="email"
            id="user_email"
            name="user_email"
            placeholder="Enter your email address"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            placeholder="Enter your message"
            rows="5"
            required
          ></textarea>
        </div>

        <button type="submit" className="submit-btn">Send</button>
      </form>

      <div className="quote-section">
        <blockquote>
          "Great development isn't just about building software; it's about solving problems and creating experiences that make a difference."
        </blockquote>
      </div>

      <footer className="contact-footer">
        <p>© 2025 Viraj Mhatre. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Contact;
